angular.module('app').factory('sidebarService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/sidebar/");

        return {
            changeOrder: function (requestData) {
                return restAngular.
                    one("changeOrder").
                    post("", requestData)
            }
        }
    }
]);
